// extracted by mini-css-extract-plugin
module.exports = {"container":"SquadNotSelected_container__DNheu","iconColor":"SquadNotSelected_iconColor__6+3aj","bold":"SquadNotSelected_bold__WlPl3","light":"SquadNotSelected_light__HHbLl"};